var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 149,
    viewBox: "0 0 100 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2644 5.34351L63.0377 3.81679V8.52672L58.4288 7V1.52672L52.2022 0V6.23664H47.5856V0L41.359 1.52672V7L36.7501 8.52672V3.81679L30.5234 5.34351L30.7447 33.3664H69.0431L69.2644 5.34351Z",
    fill: "#868694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8893 37.3438C60.4672 37.3438 69.0423 35.5632 69.0423 33.3667C69.0423 31.1703 60.4672 29.3896 49.8893 29.3896C39.3114 29.3896 30.7363 31.1703 30.7363 33.3667C30.7363 35.5632 39.3114 37.3438 49.8893 37.3438Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 119.305L50.0038 148.183L100 119.305V61.5496L50.0038 32.6641L0 61.5496V119.305Z",
    fill: "url(#paint0_linear_1729_165)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7552 106.87V81.1736H42.8086L46.1396 74.3525H55.663V106.87H48.7552Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_165",
    x1: 50,
    y1: 32.6641,
    x2: 50,
    y2: 148.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B7CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1);
export default __webpack_public_path__ + "static/media/_level-1.62be84090d573a46663d29bf2fbe31ac.svg";
export { ForwardRef as ReactComponent };